var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn-sm btn-sm-block",attrs:{"variant":"secondary","title":!_vm.disabledExport
    ? ("Descargar " + _vm.modulo)
    : ("Marque los " + _vm.modulo + " que desea descargar"),"disabled":_vm.disabledExport},on:{"click":function($event){$event.preventDefault();!_vm.disabledExport
    ? _vm.processExport()
    : ''}}},[_c('feather-icon',{attrs:{"icon":"DownloadIcon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }